import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 1.5C6.07952 1.5 3.67206 3.79009 3.52622 6.70693L3.39165 9.39817C3.38647 9.50183 3.35983 9.60329 3.31341 9.69613L2.39324 11.5365C2.29904 11.7249 2.25 11.9326 2.25 12.1432C2.25 12.8926 2.85744 13.5 3.60676 13.5H5.32501C5.67247 15.2117 7.18578 16.5 9 16.5C10.8142 16.5 12.3275 15.2117 12.675 13.5H14.3932C15.1426 13.5 15.75 12.8926 15.75 12.1432C15.75 11.9326 15.701 11.7249 15.6068 11.5365L14.6866 9.69613C14.6402 9.60329 14.6135 9.50183 14.6083 9.39817L14.4738 6.70693C14.3279 3.79009 11.9205 1.5 9 1.5ZM9 15C8.02034 15 7.18691 14.3739 6.87803 13.5H11.122C10.8131 14.3739 9.97966 15 9 15Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }